import { QueryClient } from '@tanstack/react-query';

export const mobileAdminQueryKeys = {
    root: ['mobile-admin'] as const,
    accounts: () => [...mobileAdminQueryKeys.root, 'accounts'] as const,
    account: (studentId: string) => [...mobileAdminQueryKeys.accounts(), studentId] as const,
    devices: () => [...mobileAdminQueryKeys.root, 'devices'] as const,
    deviceChanges: () => [...mobileAdminQueryKeys.devices(), 'change-requests'] as const,
    entitlements: (studentId: string) => [...mobileAdminQueryKeys.account(studentId), 'entitlements'] as const,
    delivery: (courseId: string) => [...mobileAdminQueryKeys.root, 'delivery', courseId] as const,
    materials: (courseId: string) => [...mobileAdminQueryKeys.root, 'materials', courseId] as const,
    operations: () => [...mobileAdminQueryKeys.root, 'operations'] as const,
} as const;

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            retry: (failureCount, error: unknown) => {
                const status = (error as { status?: number })?.status;
                return !status || status >= 500 ? failureCount < 2 : false;
            },
            refetchOnWindowFocus: false,
        },
        mutations: { retry: false },
    },
});

export function activeJobPollInterval(status?: string): number | false {
    return status && ['queued', 'ready', 'running', 'cancelling'].includes(status) ? 3_000 : false;
}
